<template>
  <div class="modelSet" v-dragDiv v-if="dialogVisible">
    <div class="seTitle moveDragDiv">
      设置
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <el-radio-group v-model="setType" size="mini" @change="changeSetType">
        <el-radio-button label="1" >漫游</el-radio-button>
        <el-radio-button label="2">轮廓</el-radio-button>
        <el-radio-button label="3">渲染</el-radio-button>
        <el-radio-button label="4">环境</el-radio-button>
      </el-radio-group>
    </div>
    <div class="settingPanel">
      <div v-if="setType==='1'">
        <el-form ref="form" label-width="80px">
          <el-form-item label="重力">
            <el-switch class="sideswitch" v-model="gravity"  @change="openGravity" ></el-switch>
          </el-form-item>
          <el-form-item label="碰撞">
            <el-switch class="sideswitch" v-model="collision"  @change="openCollision" ></el-switch>
          </el-form-item>
          <el-form-item label="速度">
            <el-slider class="exposure" v-model="speed" :step="0.1" :min="0" :max="10" @change="openSpeed" show-input></el-slider>
          </el-form-item>
        </el-form>
      </div>
      <div v-else-if="setType==='2'">
        <el-form ref="form" label-width="80px">
          <el-form-item label="构件边线">
            <el-switch class="sideswitch" v-model="outlineCpu"   @change="switchFunc(2)" ></el-switch>
            <span style="margin-left:10px">更精细，但计算边线可能需要一些时间</span>
          </el-form-item>
          <el-form-item label="视觉边线">
            <el-switch class="sideswitch" v-model="outlineGpu"   @change="switchFunc(4)" ></el-switch>
            <span style="margin-left:10px">显卡实时生成的边线</span>
          </el-form-item>
          <el-form-item label="抗锯齿">
            <el-switch class="sideswitch" v-model="outlineFxaa"  @change="switchFunc(32)" ></el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div v-else-if="setType==='3'">
        <el-form ref="form" label-width="120px">
          <el-form-item label="单双面渲染">
            <el-radio-group v-model="single"  class="radiotemp" @change="setSide()" >
              <el-radio :label="0" >单面</el-radio>
              <el-radio :label="2" >双面</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="渲染质量">
            <el-radio-group v-model="piexl" class="radiotemp" @change="setPixelLimit()" >
                <el-radio :label="5" >极低</el-radio>
                <el-radio :label="4" >低</el-radio>
                <el-radio :label="3" >中</el-radio>
                <el-radio :label="2" >高</el-radio>
                <el-radio :label="1" >极高</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="每帧渲染时间">
            <el-slider class="exposure" v-model="frameval" :step="1" :min="50" :max="400" @change="setFrame" show-input></el-slider>
          </el-form-item>
        </el-form>
      </div>
      <div v-else-if="setType==='4'">
        <el-form ref="form" label-width="120px">
          <el-form-item label="背景">
            <el-radio-group v-model="sBG"  class="radiotemp" @change="setBG" >
              <el-radio :label="-1" >天空盒</el-radio>
              <el-radio :label="0" >深色</el-radio>
              <el-radio :label="1" >浅色</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="环境光遮罩">
            <el-switch class="sideswitch" v-model="envSsao"  @change="switchFunc(16)" ></el-switch>
            <span>（SSAO）</span>
          </el-form-item>
          <el-form-item label="色温">
            <el-radio-group v-model="temperature"  class="radiotemp" @change="setTemperature()" >
                <el-radio :label="-1" >冷色</el-radio>
                <el-radio :label="0" >正常</el-radio>
                <el-radio :label="1" >暖色</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="曝光度">
            <el-slider class="exposure" v-model="hard" :step="1" :min="0" :max="100" @change="setHard" show-input></el-slider>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      dialogVisible:false,
      setType:'1',
      outlineCpu: false,
      outlineGpu: false,
      outlineFxaa: false,
      settingact: false,
      settingData: [],
      hard: 0.6,
      temperature: 0,
      single: 0,
      envSsao: false,
      piexl: "",
      frameval: 100,
      gravity: false,
      collision: false,
      speed: 0,
      sBG: -1,
    }
  },
  mounted(){
  },
  methods:{
    init(){
      this.setType = '1';
      this.speed = Monge.Model.Walk.getSpeed();
      // this.gravity = Monge.Model.Walk.getGravity();
      this.collision = Monge.Model.Walk.getCollide();

      this.temperature = Monge.Model.Light.getTemperature();
      this.hard = Monge.Model.Light.getIntensity() * 100;
      // debugger
      this.piexl = Monge.Model.getPixelLimit();
      this.frameval = Monge.Model.getFrameRate();
      this.gravity = Monge.Model.Walk.getGravity();
      this.collision = Monge.Model.Walk.getCollide();
      this.single = Monge.Model.getMaterilaSide();
      
      var bg = Monge.Model.getBackground();
      if (bg.x === -1) {
        this.sBG = -1;
      } else if (bg.x === 33) {
        this.sBG = 0;
      } else if (bg.x === 240) {
        this.sBG = 1;
      }
      this.settingData=[]
      var opt = Monge.Model.getOption();
      var effect = Monge.Model.Effect.getEffectType();
      if (opt & effect.SSAO) {
        this.settingData.push(16);
        this.envSsao = true;
      }
      if (opt & effect.Profile) {
        this.settingData.push(2);
        this.outlineCpu = true;
      }
      if (opt & effect.FXAA) {
        this.settingData.push(32);
        this.outlineFxaa = true;
      }
      if (opt & effect.FouLine) {
        this.settingData.push(4);
        this.outlineGpu = true;
      }
    },
    changeSetType(){
      // console.log(this.setType);
      // debugger
    },
    openGravity() {
      Monge.Model.Walk.setGravity(this.gravity);
    },
    openCollision() {
      Monge.Model.Walk.setCollide(this.collision);
    },
    openSpeed() {
      Monge.Model.Walk.setSpeed(this.speed);
    },
    setFrame(val) {
      Monge.Model.setFrameRate(val);
    },
    setHard() {
      //曝光强度
      Monge.Model.Light.setIntensity(this.hard / 100);
    },
    switchFunc(val) {
      if (val === 2) {
        this.outlineCpu ? Monge.Model.Effect.depictProfile(true) : Monge.Model.Effect.depictProfile(false);
      } else if (val === 4) {
        this.outlineGpu ? Monge.Model.Effect.fouLine(true) :Monge.Model.Effect.fouLine(false);
      } else if (val === 16) {
        this.envSsao ? Monge.Model.Effect.SSAO(true) : Monge.Model.Effect.SSAO(false);
      } else if (val === 32) {
        this.outlineFxaa ? Monge.Model.Effect.FXAA(true) : Monge.Model.Effect.FXAA(false);
      }
    },
    setBG() {
      if (this.sBG == "-1") {
        Monge.Model.setBackground(-1, -1, -1);
      } else if (this.sBG == "0") {
        Monge.Model.setBackground(33, 40, 48);
      } else if (this.sBG == "1") {
        Monge.Model.setBackground(240, 240, 240);
      }
    },
    setPixelLimit() {
      Monge.Model.setPixelLimit(this.piexl);
    },
    setTemperature() {
      //色温
      Monge.Model.Light.setTemperature(this.temperature)
    },

    openSet(){
      this.dialogVisible=true;
      this.$nextTick(()=>{
        this.init()
      })
    },

    closeArea(){
      this.dialogVisible=false;
    },

  }
}
</script>

<style lang="scss" scoped>
.modelSet{
  position: absolute;
  width: 520px;
  height: 460px;
  top: calc(50% - 230px);
  left: calc(50% - 260px);
  background: rgba(255, 255, 255, 0.85);
  border-radius: 4px;
  .seTitle{
    width: 100%;
    height: 50px;
    padding: 0 15px;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    user-select: none;
    cursor: move;
    i{
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: 50px;
    padding: 5px 10px;
  }
  .settingPanel{
    width: 100%;
    height: 50px;
    padding: 5px 10px;
  }
}
</style>